/**
 * True when `url` is a non-empty string whose scheme is `https://`
 * (case-insensitive, after trimming surrounding whitespace).
 *
 * Returns `false` for `null`, `undefined`, empty, or whitespace-only inputs so
 * callers in auth / redirect flows can safely branch on the result without
 * needing their own null guard (a crash here would abort the post-login
 * navigation entirely).
 */
export function isExternalHttpsRedirect(url: string | null | undefined): boolean {
  if (!url) return false
  return url.trim().toLowerCase().startsWith('https://')
}
